<app-page-template
  [class.d-none]="isVisibleLoginAuditPage"
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (onShowHelpPage)="onShowHelpPage()"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!--------------------------------------- login Audit btns ---------------------------------------->
  <div
    class="card-toolbar"
    before-btns
    *ngIf="currentUserInfo.organizationId == 1"
  >
    <!-- login audits btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onLoginAudits()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.loginAudits' | translate"
    >
      <i class="mdi mdi-eye mdi-20px tw-p-0 text-info"></i>
    </button>
  </div>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- userName -->
        <td>
          <td-value copyToClipboard [value]="item?.userName"></td-value>
        </td>

        <!-- ipAddress -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.ipAddress | ipDisplayer"
          ></td-value>
        </td>

        <!-- browser -->
        <td style="max-width: 200px">
          <span *ngIf="item?.browser" [matTooltip]="item?.browserName">
            <i [browserIcon]="item?.browser"></i>
          </span>
          <span *ngIf="!item?.browser">
            {{ item?.browserName }}
          </span>
        </td>

        <!-- device -->
        <td style="max-width: 200px">
          <span
            *ngIf="item?.device"
            [matTooltip]="item?.device | enumValue : Device"
          >
            <i [deviceIcon]="item?.device"></i>
          </span>
          <span *ngIf="!item?.device">
            {{ item?.device | enumValue : Device }}
          </span>
        </td>

        <!-- os -->
        <td style="max-width: 200px">
          <span *ngIf="item?.platform" [matTooltip]="item?.os">
            <i [platformIcon]="item?.platform"></i>
          </span>
          <span *ngIf="!item?.platform">
            {{ item?.os }}
          </span>
        </td>

        <!-- isSignOut -->
        <td>
          <span *ngIf="!item?.isSignOut">
            <i
              [matTooltip]="'common.login' | translate"
              class="mdi mdi-location-enter text-success mdi-22px mdi-rotate-180"
            ></i>
          </span>
          <span *ngIf="item?.isSignOut">
            <i
              [matTooltip]="'common.isSignOut' | translate"
              class="mdi mdi-location-exit text-danger mdi-22px"
            ></i>
          </span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------------------------------- Login audit ---------------->
<ng-container *ngIf="isVisibleLoginAuditPage">
  <app-login-audits
    (hideLoginAuditPage)="isVisibleLoginAuditPage = false"
    [title]="pageConfig.title"
  >
  </app-login-audits>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
